import { InfoAdapterType } from "features/shared/types/info";
import { SelectionValue } from "features/shared/types/select";
import { Tag } from "features/shared/types/tag";

export const initialFields: Tag = {
    key: "",
    value: {
        type: InfoAdapterType.DefaultInfo,
    },
};

export const TAG_SELECTION_OPTIONS: Array<SelectionValue<InfoAdapterType>> = [
    {
        display: "Default Tag",
        value: InfoAdapterType.DefaultInfo,
    },
    {
        display: "Custom Tag",
        value: InfoAdapterType.StringInfo,
    },
];
